import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Modal } from 'react-bootstrap';
import { CheckBoxSingle } from 'components/checkboxes/check-box-single';
import * as ProjectActionType from 'Projects/constants';
import { connect } from 'react-redux';
import queryString from 'query-string';
import {withRouter} from 'react-router-dom';
import {isEmpty} from 'lodash';

class ItemLotAssign extends Component {
    static propTypes = {
      projectId: PropTypes.string,
      isOpen: PropTypes.bool,
      location: PropTypes.any,
      history: PropTypes.any,
      onClose: PropTypes.func,
      dispatch: PropTypes.func,
      inventoryItemId: PropTypes.string,
      InventoryItemSharedLot: PropTypes.array
    }

    constructor(props) {
      super(props);

      this.state = {
        lotCheckList: {},
        sharedPlans: null
      };
    }

    componentDidMount() {
      this.props.dispatch({
        type: ProjectActionType.GET_LIST_PHASE_TO_LOT_INVENTORY_ITEM_ASYNC,
        params: {
          search: null,
          inventoryItemId: this.props.inventoryItemId
        },
        callback: this.onInitialLotCheckList
      });
    }

    componentWillReceiveProps(nextProps) {
      if (this.props.InventoryItemSharedLot !== nextProps.InventoryItemSharedLot) {
        this.setState({
          sharedPlans: nextProps.InventoryItemSharedLot
        });
      }
    }

    onInitialLotCheckList = data => {
      let initialLotCheckList = {};
      data.map(phase => {
        let lotIdList = {};

        phase.lots.map(lot => {
          lotIdList[lot.id] = lot.checked;
        });

        initialLotCheckList[phase.planId] = lotIdList;
      });

      this.setState({
        lotCheckList: initialLotCheckList
      });
    };

    onClose = () => {
      this.props.onClose();
    }

    onCheckPhase = (e, value, data) => {
      const currentStateLotCheckList = { ...this.state.lotCheckList };

      let lotList = { ...currentStateLotCheckList[value] };

      Object.keys(lotList).map(item => {
        lotList[item] = data.checked;
      });

      currentStateLotCheckList[value] = lotList;

      let sharedPlans = [...this.state.sharedPlans];
      console.log(sharedPlans, 'sharedPlans');
      this.searchInput.value = '';

      this.setState({
        lotCheckList: currentStateLotCheckList,
        sharedPlans
      });
    };

    onCheckLot = (e, value, data) => {
      const planId = value.split(',')[0];
      const lotId = value.split(',')[1];
      const currentStateLotCheckList = { ...this.state.lotCheckList };

      currentStateLotCheckList[planId][lotId] = data.checked;

      this.setState({
        lotCheckList: currentStateLotCheckList
      });
    };

    onDetectPhaseCheckBoxStatus = planId => {
      const { lotCheckList } = this.state;

      const lotList = { ...lotCheckList[planId] };

      const lotListStatus = Object.values(lotList);

      if (!lotListStatus.includes(true)) {
        return -1;
      }

      if (!lotListStatus.includes(false)) {
        return 1;
      }

      return 0;
    };

    onKeyPressSearchInput = e => {
      if (e.key === 'Enter') {
        const searchValue = this.searchInput.value.toLowerCase();

        const currentSharedPlans = [
          ...this.props.InventoryItemSharedLot
        ];

        let newSharedPlans = [];

        currentSharedPlans.map(plan => {
          const lotList = plan.lots;

          let itemSharedPlans = {
            planId: plan.planId,
            planName: plan.planName
          };

          console.log(itemSharedPlans, 'sharedPlans');
          let newLots = [];

          lotList.map(lot => {
            const { name, streetAddress } = lot;

            if (
              name.toLowerCase().includes(searchValue) ||
              streetAddress.toLowerCase().includes(searchValue)
            ) {
              newLots.push(lot);
            }
          });

          if (newLots.length) {
            itemSharedPlans['lots'] = newLots;

            newSharedPlans.push(itemSharedPlans);
          }
        });

        this.setState({
          sharedPlans: newSharedPlans
        });
      }
    };

    onCheckListEmpty = () => {
      let {sharedPlans} = this.state;
      let initialLotCheckList = [];
      sharedPlans && (sharedPlans.map(phase => {
        let lotIdList = [];

        phase.lots.map(lot => {
          lotIdList.push(lot.checked);
        });

        initialLotCheckList.push(lotIdList);
      })
      );

      let listTrue = [].concat.apply([], initialLotCheckList);

      if (listTrue.some(x => x === true)) {
        return false;
      }
      return true;
    }

    onSave = () => {
      const {location} = this.props;
      const queryParams = queryString.parse(location.search);
      let addShareLots = [];
      let removeShareLots = [];

      const { lotCheckList } = this.state;

      const {
        InventoryItemSharedLot
      } = this.props;

      let initialLotCheckList = {};

      InventoryItemSharedLot.map(plan => {
        let lotIdList = {};

        plan.lots.map(lot => {
          lotIdList[lot.id] = lot.shared;
        });

        initialLotCheckList[plan.planId] = lotIdList;
      });

      const planList = Object.keys(lotCheckList);

      planList.map(planId => {
        const lotList = Object.keys(lotCheckList[planId]);

        lotList.map(lotId => {
          if (
            lotCheckList[planId][lotId] !== initialLotCheckList[planId][lotId]
          ) {
            if (lotCheckList[planId][lotId]) {
              addShareLots.push({ planId, lotId });
            } else {
              removeShareLots.push({ planId, lotId });
            }
          }
        });
      });

      let listLots = addShareLots.map(id => id.lotId);
      if (isEmpty(listLots)) {
        this.props.onClose();
      } else {
        this.props.dispatch({
          type: ProjectActionType.ASSIGN_PLAN_TO_LOT_INVENTORY_ITEM_ASYNC,
          params: {
            inventoryItemId: this.props.inventoryItemId,
            lotIds: listLots
          },
          callback: () => {
            this.props.dispatch({
              type: ProjectActionType.GET_LIST_LOT_ASSIGN_INVENTORY_ITEM_ASYNC,
              params: {
                id: this.props.inventoryItemId
              }, callback: () => this.props.onClose()
            });
          }
        });
      }

    }

    renderPlanListSideBar = (sharedPlans) => {
      return (
        <div className='phase-list'>
          <ul>
            {sharedPlans &&
            sharedPlans.map((item, index) => {
              const checkStatus = this.onDetectPhaseCheckBoxStatus(item.planId);

              return (
                <li key={index}>
                  <CheckBoxSingle
                    ref={c => {
                      this.phase = c;
                    }}
                    checked={checkStatus === 1 ? true : false}
                    indeterminate={checkStatus === 0}
                    value={item.planId}
                    label={item.planName}
                    onChecked={this.onCheckPhase}
                    name='phase'
                    className='checkbox-default ckb-phase-pick'
                  />
                </li>
              );
            })}
          </ul>
        </div>
      );
    }

    renderMainLotList = (sharedPlans) => {
      const { lotCheckList } = this.state;
      return (
        <div className='main-lot-list'>
          <div className='lot-search-box form-group'>
            <input
              ref={ref => {
                this.searchInput = ref;
              }}
              className='form-control search-lot-input'
              placeholder='Lot# / Street address'
              onKeyPress={this.onKeyPressSearchInput}
            />
            <i className='fa fa-search search-lot-ic' />
          </div>

          <div className='lot-list'>
            {sharedPlans &&
              sharedPlans.map((item, index) => {
                return (
                  <div className='lot-block' key={index}>
                    <p className='phase-header'>{item.planName}</p>

                    <ul>
                      {item.lots.map((lot, i) => {
                        const currentChecked = lotCheckList[item.planId]
                          ? lotCheckList[item.planId][lot.id]
                          : false;
                        return (
                          <li key={i}>
                            <CheckBoxSingle
                              ref={c => {
                                this.lot = c;
                              }}
                              checked={currentChecked || false}
                              value={`${item.planId},${lot.id}`}
                              label={`${lot.name}, ${lot.streetAddress}`}
                              onChecked={this.onCheckLot}
                              name='lot'
                              className='checkbox-default ckb-lot-pick'
                            />
                          </li>
                        );
                      })}
                    </ul>
                  </div>
                );
              })}
          </div>
        </div>
      );
    }

    render() {
      const {isOpen} = this.props;
      const {sharedPlans} = this.state;

      // const checkListEmpty = this.onCheckListEmpty();
      return (
        <Modal className='sharing-file-with-lot-modal' show={isOpen}>
          <button className='close' onClick={this.onClose} >&times;</button>
          <p className='md-header'>Pick lots in which this item is installed</p>
          <div className='pick-lot-wrapper'>
            {this.renderPlanListSideBar(sharedPlans)}

            {this.renderMainLotList(sharedPlans)}
          </div>
          <div>
            <button
              className='btn btn-primary btn-siteone-default'
              onClick={this.onClose}
            >
            Cancel
            </button>
            <button className='btn btn-primary btn-siteone' onClick={this.onSave}>
            Save
            </button>
          </div>
        </Modal>
      );
    }
}

const mapStateToProps = state => {
  return {
    InventoryItemSharedLot: state.ProjectStore.InventoryItemSharedLot,
    inventoryItemId: state.ProjectStore.inventoryItemId
  };
};

export default withRouter(connect(mapStateToProps)(ItemLotAssign));



// WEBPACK FOOTER //
// ./src/Projects/Components/Inventory/item-lot-assign.js